module.exports = {"component":"global-navigation-bar","status":"prototype","display-name":"Global Navigation Bar","last-accessibility-review":{"date-iso-8601":"2017/05/02","commit-sha":"ad6b6c6523ee21cada11be5f7ea4d99abc530726"},"SLDS-component-path":"/components/global-navigation","dependencies":[{"component":"button"},{"component":"dropdown"},{"component":"label"},{"component":"link"},{"component":"region"}],"url-slug":"global-navigation-bar"}


//////////////////
// WEBPACK FOOTER
// ./components/global-navigation-bar/docs.json
// module id = 128
// module chunks = 0